import { type ComunicazioneDTO } from '@framework/api-client/api/backoffice/schemas/comunicazioneDTO.ts';
import { CommunicationLogic } from '../logic/CommunicationLogic.ts';
import { CommunicationRecipient } from './CommunicationRecipient.tsx';

export interface ICommunicationRecipientsViewProps {
  communication: ComunicazioneDTO | null | undefined;
  compactView?: boolean;
}

/**
 * Destinatari di una comunicazione
 */
export function CommunicationRecipientsView(
  props: ICommunicationRecipientsViewProps,
) {
  const { communication, compactView } = props;
  if (!communication) return null;

  const recipients = CommunicationLogic.allRecipients(communication);

  return recipients?.map(recipient => (
    <CommunicationRecipient
      key={recipient.id}
      recipient={recipient}
      communication={communication}
      compactView={compactView}
    />
  ));
}
